<template>
    <div class="flex px-2 space-x-1">
        <slot></slot>
    </div>
</template>
